import React from "react"
import {Badge} from "../Badge/Badge"
import classNames from "classnames"
import {
	formatNameMismatchTypesForDisplay,
	normalizeNameMatchKey,
} from "../AssignmentPageItemNameMismatch/nameMismatchPartyRoles"
import {UnscoredRow} from "./UnscoredRow"

interface NamesScoreTableProps {
	namesScoreMap: Record<string, string>
	nameRoleMap?: Record<string, string[]>
	unscoredNames?: string[]
	disabled?: boolean
}

export function NamesScoreTable({namesScoreMap, nameRoleMap, unscoredNames = [], disabled}: NamesScoreTableProps) {
	const shouldShowTypeColumn = Boolean(nameRoleMap)

	const scoredKeys = new Set(Object.keys(namesScoreMap).map(normalizeNameMatchKey))
	const unscoredRows = unscoredNames
		.filter((name) => !scoredKeys.has(normalizeNameMatchKey(name)))
		.sort((a, b) => a.localeCompare(b))

	return (
		<div className="names-score-table">
			<table className={shouldShowTypeColumn ? "has-type-column" : ""}>
				<thead>
					<tr>
						<th className="table-header">Names</th>
						{shouldShowTypeColumn && <th className="table-header">Type</th>}
					</tr>
				</thead>
				<tbody>
					{Object.entries(namesScoreMap)
						.sort(([, scoreA], [, scoreB]) => parseInt(scoreB, 10) - parseInt(scoreA, 10))
						.map(([name]) => (
							<tr key={`scored:${name}`}>
								<td className={classNames("name-cell", disabled && "disabled")}>
									<Badge className="badge-text" text={name} />
								</td>
								{shouldShowTypeColumn && (
									<td className={classNames(disabled && "disabled")}>
										{formatNameMismatchTypesForDisplay(nameRoleMap?.[normalizeNameMatchKey(name)])}
									</td>
								)}
							</tr>
						))}
					{unscoredRows.map((name) => (
						<UnscoredRow
							key={`unscored:${name}`}
							name={name}
							nameRoleMap={nameRoleMap}
							showTypeColumn={shouldShowTypeColumn}
							disabled={disabled}
						/>
					))}
				</tbody>
			</table>
		</div>
	)
}
